import React from 'react';
import styled from 'styled-components';
import { usePrivy, useLogin } from '@privy-io/react-auth';
import PWAHeader from '../../components/pwa/PWAHeader';
import PWABottomNav from '../../components/pwa/PWABottomNav';
import CustomSwapWidget from '../../components/swap/CustomSwapWidget';

const PWAContainer = styled.div`
  min-height: 100vh;
  background: #000000;
  display: flex;
  flex-direction: column;
  
  /* Desktop PWA constraint */
  @media (min-width: 768px) {
    max-width: 414px;
    width: 414px;
    margin: 0 auto;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.8), 
                0 0 0 12px rgba(0, 0, 0, 0.5),
                0 0 0 16px #333333;
    border-radius: 24px;
    overflow: hidden;
  }
`;

const ContentArea = styled.main`
  flex: 1;
  padding: 16px;
  padding-bottom: 100px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  text-align: center;
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

const PageSubtitle = styled.p`
  font-size: 14px;
  color: #71717a;
  margin: 0 0 24px 0;
  text-align: center;
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

const SwapContainer = styled.div`
  width: 100%;
  max-width: 100%;
  
  /* Override BuySellPanel styles for PWA */
  & > div {
    max-width: 100%;
    border-radius: 16px;
  }
`;

const SignInPrompt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  gap: 20px;
`;

const SignInMessage = styled.p`
  font-size: 16px;
  color: #a1a1aa;
  font-family: 'Plus Jakarta Sans', sans-serif;
  max-width: 280px;
`;

const SignInButton = styled.button`
  padding: 14px 32px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Plus Jakarta Sans', sans-serif;
  
  &:hover {
    background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
    transform: translateY(-2px);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }
`;

const SwapPWA: React.FC = () => {
  const { ready, authenticated } = usePrivy();
  
  const { login } = useLogin({
    onComplete: () => {
      console.log('✅ PWA Swap: Login complete');
    },
    onError: (error) => {
      console.error('❌ PWA Swap: Login error:', error);
    },
  });

  return (
    <PWAContainer>
      <PWAHeader />
      
      <ContentArea>
        <PageTitle>Swap</PageTitle>
        <PageSubtitle>Trade tokens on Ink Chain</PageSubtitle>
        
        {authenticated ? (
          <SwapContainer>
            <CustomSwapWidget />
          </SwapContainer>
        ) : (
          <SignInPrompt>
            <i className="fas fa-exchange-alt" style={{ fontSize: 48, color: '#333333' }} />
            <SignInMessage>
              Sign in to swap tokens with low fees on Ink Chain
            </SignInMessage>
            <SignInButton onClick={() => login()} disabled={!ready}>
              {ready ? 'Sign In to Swap' : 'Loading...'}
            </SignInButton>
          </SignInPrompt>
        )}
      </ContentArea>
      
      <PWABottomNav />
    </PWAContainer>
  );
};

export default SwapPWA;

